import React, {useEffect, useState, useCallback, useRef} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Menu} from '../../utils/menu/Menu';
import {mailingsAction, mailingDeleteAction} from '../../actions/mailingAction';
import {curatorsAction} from "../../actions/usersAction";
import cfg, {coursePeriods, formatErrors, roleCurator, userPrintName, roleChiefNutritionist} from '../../constants';
import {toast} from 'react-toastify';
import {SortItem} from '../../utils/sortItem/SortItem';
import {ButtonMore} from '../../utils/buttonMore/buttonMore';
import {Pagination} from '../../utils/pagination/Pagination';
import {ConfirmModal} from "../../utils/confirm/ConfirmModal";
import {SortItemFilter} from "../../utils/sortItem/SortItemFilter";
import {MenuHeader} from "../../utils/menu/MenuHeader";
import {MailingEditModal} from "./utils/MailingEditModal";

const Mailing = (props) => {
  const {user, isCurator, getMailings, getCurators} = props;
  const [users, setUsers] = useState([]);
  const [usersNames, setUsersNames] = useState({});
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({});
  const abortRef = useRef(null);

  const handleChangeFilter = useCallback((field, value) => {
    setFilter((data) => {
      return {...data, [field]: value, page: 1}
    });
  }, []);

  const handleChangePage = useCallback((value) => {
    setFilter((data) => {
      return {...data, page: value}
    });
  }, []);

  const handleChangeSort = useCallback((sort, sortd) => {
    setFilter((data) => {
      return {...data, sort, sortd}
    });
  }, []);

  // get curators list
  const getCuratorsList = useCallback(() => {
    getCurators().then((data) => {
      let list = [{ key: '', text: 'Все', value: '' }];
      let names = {};
      (data || []).forEach((i) => {
        let name = userPrintName(i);
        list.push({key: i.id, text: name, value: i.id});
        names[i.id] = name;
      });
      setUsers(list);
      setUsersNames(names);
    }).catch(err => {
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }, [getCurators]);

  // get mailing list
  const getMailingList = useCallback((filter) => {
    if (abortRef && abortRef.current) {
      abortRef.current.abort();
    }
    const abortNew = new AbortController();
    abortRef.current = abortNew;
    getMailings(filter, abortRef && abortRef.current ? abortRef.current.signal : null).then((data) => {
      abortRef.current = null;
      setItems(data.items || []);
      setTotal(data.total);
      localStorage.setItem('dc_currentMailingsFilter', JSON.stringify(filter));
    }).catch(err => {
      if (err.name !== 'AbortError') {
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      }
      abortRef.current = null;
    });
  }, [getMailings]);

  const handleDelete = (id) => {
    return new Promise((resolve, reject) => {
      if (loading) {
        return resolve(false);
      }
      setLoading(true);
      props.deleteMailing(id).then(() => {
        setLoading(false);
        resolve(true);
        toast.success('Рассылка удалена', {position: toast.POSITION.BOTTOM_RIGHT});
        if (filter.page > 1 && (filter.page - 1) * filter.limit >= total - 1) {
          setFilter({...filter, page: filter.page - 1});
        } else {
          getMailingList(filter);
        }
      }).catch(err => {
        setLoading(false);
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        reject(err);
      });
    });
  };

  // get mailings list on change filter
  useEffect(() => {
    if (filter.page) {
      getMailingList(filter);
    }
  }, [filter, getMailingList]);

  useEffect(() => {
    if (!user || !user.id) {
      return;
    }
    const baseFilter = {page: 1, limit: 10, sort: 'created', sortd: 'desc', user_id: ''};
    let curFilter = localStorage.getItem('dc_currentMailingsFilter');
    curFilter = curFilter ? JSON.parse(curFilter) : baseFilter;
    curFilter.page = !curFilter.page ? 1 : curFilter.page;
    if (user.role_id === roleCurator || user.role_id === roleChiefNutritionist) {
      curFilter.user_id = user.id;
    } else {
      curFilter.user_id = "";
    }
    getCuratorsList();
    setFilter(curFilter);
  }, [user, getCuratorsList]);

  return <div className="content">
    <Menu isStatic={(user.role_id === roleCurator || user.role_id === roleChiefNutritionist) ? false : true}/>

    {!isCurator && <div className="heading heading--flex">
      <h2 className="heading__title">Рассылки</h2>
    </div>}
    {isCurator && <MenuHeader>
      <React.Fragment>
        <h2 className="header__title">Рассылки <span>{total}</span></h2>
      </React.Fragment>
    </MenuHeader>}
    <div className="users">
      <div className="users__wrapper">
        <div className="sort">
          <SortItem title="Сообщение" className="sort__item--name" sort="message_text" sortd={filter.sort === "message_text" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Создана" className="sort__item--email" sort="created" sortd={filter.sort === "created" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Файл" className="sort__item--phone" sort="file" sortd={filter.sort === "file" ? filter.sortd : ""} onChange={handleChangeSort}/>
          {!isCurator && <SortItemFilter title="Куратор" className="sort__item--curator" name="user_id" value={filter.user_id} onChange={handleChangeFilter} options={users}/>}
          <SortItem title="Пользователи" className="sort__item--course"/>
          <SortItem title="Ступени программы" className="sort__item--course sort__item--course-max"/>
        </div>
        <div className="users__inner">
          {
            items && items.length > 0 && items.map((i) => <div key={i.id} className="users__item">
              <span className="users__name">{i.message_text}</span>
              <span className="users__email">{i.created.split('.')[0].split('T').join(' ')}</span>
              <span className="users__phone">{i.file && <a href={cfg.public_url + 'auth/file/' + i.user_id + '/i/' + i.file} target="_blank" rel="noreferrer" className="attached--icon">{i.file.toUpperCase().split('.').pop()}</a>}</span>
              {!isCurator && <span className="users__curator">{i.user_id && usersNames[i.user_id] ? usersNames[i.user_id] : ''}</span>}
              <span className="users__users">{i.client_ids ? i.client_ids.split(',').length : 'Все'}</span>
              <span className="users__course users__course--max">{i.program_stages ? i.program_stages.split(',').map((pi) => coursePeriods[pi].title).join(',') : 'Любая'}</span>
              <ButtonMore>
                <ul className="dropdown">
                  <li className="dropdown__item icon-edit">
                    <MailingEditModal trigger={<span>Редактировать</span>} usersNames={usersNames} user={user} item={i} onSuccess={() => getMailingList(filter)}/>
                  </li>
                  <li className="dropdown__item icon-delete">
                    <ConfirmModal trigger={<span>Удалить</span>} triggerWrap={false} title={"Удалить рассылку?"} handleOk={() => handleDelete(i.id)}/>
                  </li>
                </ul>
              </ButtonMore>
            </div>)
          }
        </div>
      </div>
    </div>

    {filter.page && filter.page > 0 && <Pagination page={filter.page} total={total} limit={filter.limit} onChange={handleChangePage}/>}
  </div>;
};

const mapStateToProps = (state) => ({
  user: state.user.profile,
  isCurator: state.user.profile && (state.user.profile.role_id === roleCurator || state.user.profile.role_id === roleChiefNutritionist)
});

const mapDispatchToProps = (dispatch) => {
  return {
    getMailings(data, signal) {
      return dispatch(mailingsAction(data, signal));
    },
    deleteMailing(id) {
      return dispatch(mailingDeleteAction(id));
    },
    getCurators() {
      return dispatch(curatorsAction());
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Mailing))
